import './styled.scss';
import { useEffect, useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react';
import dayjs from 'dayjs';
import FooterEventModel from 'common-modules/general/Common/Logic/Event/EventCommon';
import { toJS } from 'mobx';
import { APIClientBaseURL } from 'common-modules/general/Config/constants';
import { cdBizLnd } from 'data/configs';
import Pagination from 'pages/mobile/Sales/Pagination/Pagination';
import NoResultWithLabel from 'common-modules/general/Common/Components/NoResultWithLabel';
import { isAfter, isBefore } from 'common-modules/general/Modules/functions';
import { RoutesString } from 'common-modules/general/Config/routesString';
import { useHistory } from 'react-router';
import replaceImg from 'assets/Mobile/images/common/img_myhome_show.jpg';

const Event = observer(() => {
  const [type, setType] = useState('1');
  const [currentPage, setCurrentPage] = useState(1);
  const { model: eventModel } = useLocalObservable(() => ({ model: new FooterEventModel() }));
  const history = useHistory();

  useEffect(() => {
    eventModel.getEventListData({ state: type, cdBizLnd: cdBizLnd });
  }, [type, eventModel]);

  const handlePageMove = (sral: string) => {
    history.push(`${RoutesString.SalesEventDetail}/?id=${sral}`);
  };

  const renderProcess = (startDate, endDate) => {
    if (isAfter(startDate)) {
      return '예정';
    } else if (isBefore(endDate)) {
      return '진행중';
    } else {
      return '종료';
    }
  };

  const renderProcessTag = endDate => {
    const flag = isBefore(endDate);
    if (flag) {
      return 'ing';
    } else {
      return 'intend';
    }
  };

  const isIngEvent = (endDate: string): boolean => {
    const flag = isBefore(endDate);

    if (flag) {
      return false;
    } else {
      return true;
    }
  };

  const eventList = toJS(eventModel.eventList.data?.list);
  const totalCount = eventModel.eventList.data?.totalPage || 0;

  return (
    <div className="contents-event-mobile">
      <>
        <div className="sub-tab-menu clfix">
          <div className={`btn ${type === '1' ? 'on' : ''}`} onClick={() => setType('1')}>
            전체
            <span className="hide-txt">선택됨</span>
          </div>
          <div className={`btn ${type === '2' ? 'on' : ''}`} onClick={() => setType('2')}>
            진행중
            <span className="hide-txt">선택됨</span>
          </div>
          <div className={`btn ${type === '3' ? 'on' : ''}`} onClick={() => setType('3')}>
            종료
            <span className="hide-txt">선택됨</span>
          </div>
        </div>

        <div className="input-custom container">
          <div className="input-control">
            <div className="input-area">
              <div className="input">
                <input id="test-1001" type="text" title="검색어 입력" />
              </div>
            </div>
          </div>
          <button type="button">
            <span className="ico-search"></span>
          </button>
        </div>

        <div className="pt-10 event-container">
          <ul className="event-type01">
            {eventList &&
              eventList.length > 0 &&
              eventList.map((item, key) => (
                <li className={`item ${isIngEvent(item.dtEnd) && 'event-end'}`} key={key}>
                  <div
                    onClick={() => {
                      handlePageMove(item.noEvntSral);
                    }}>
                    <div className="img-area">
                      {item.noThumSral ? (
                        <img src={`${APIClientBaseURL.file}${item.noThumSral}`} alt="img" />
                      ) : (
                        <img src={replaceImg} alt="img" />
                      )}
                    </div>

                    <div className="txt-area container">
                      <span className={`tag-tit ${renderProcessTag(item.dtEnd)}`}>{renderProcess(item.dtBegn, item.dtEnd)}</span>
                      <p className="tit">{item.nmBiz}</p>
                      <span className="txt">{item.sbjtNtcPlte}</span>
                      <p className="date">
                        {dayjs(item.dtBegn).format('YYYY.MM.DD')} ~ {dayjs(item.dtEnd).format('YYYY.MM.DD')}
                      </p>
                    </div>
                  </div>
                </li>
              ))}
          </ul>
          {eventList && eventList.length === 0 && <NoResultWithLabel>결과가 없습니다.</NoResultWithLabel>}
        </div>

        <Pagination limit={10} currentPage={currentPage} setCurrentPage={setCurrentPage} totalCount={totalCount * 10} />
      </>
    </div>
  );
});

export default Event;
